<!-- question-dialog.component.html -->
<h2 mat-dialog-title>{{ question.question }}</h2>

<mat-dialog-content>
  <!-- Information type question -->

  @if(question.type === 'information' && sanitizedHtml) {
  <div [innerHTML]="sanitizedHtml"></div>
  }

  <!-- Single choice question -->
  @if(question.type === 'single-choice' && !showRationale) {
  <form [formGroup]="form">
    <mat-radio-group formControlName="singleChoice" class="radio-group">
      @for(option of question.options; track question.id; let i = $index) {
      <mat-radio-button [value]="i" class="radio-button">
        {{ option.text }}
      </mat-radio-button>
      }
    </mat-radio-group>
  </form>
  }

  <!-- Multiple choice question -->
  @if(question.type === 'multiple-choice' && !showRationale) {
  <form [formGroup]="form">
    <div formArrayName="multipleChoices">
      @for(option of question.options; track question.id; let i = $index) {
      <mat-checkbox [formControlName]="i" class="checkbox-option">
        {{ option.text }}
      </mat-checkbox>
      }
    </div>
  </form>
  }

  <!-- Rationale display -->
  @if(showRationale) {
  <div class="rationale rationale-content">
    <div
      [ngClass]="{ correct: result.correct, incorrect: !result.correct }"
      class="result-indicator"
    >
      <mat-icon>{{ result.correct ? "check_circle" : "cancel" }}</mat-icon>
      <span>{{ result.correct ? "Correct" : "Incorrect" }}</span>
    </div>
    <p class="rationale-text">{{ result.message || question.rationale }}</p>
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if(question.type === 'information') {
  <button
    mat-flat-button
    id="close-button"
    [mat-dialog-close]="result"
    matTooltip="Continue"
    matTooltipShowDelay="1000"
    aria-label="Continue"
  >
    Continue
  </button>
  } @if((question.type === 'single-choice' || question.type ===
  'multiple-choice') && !showRationale) {
  <button
    mat-flat-button
    id="submit-button"
    (click)="onContinue()"
    [disabled]="isSubmitDisabled()"
    matTooltip="Submit"
    matTooltipShowDelay="1000"
    aria-label="Submit"
  >
    Submit
    <mat-icon>check</mat-icon>
  </button>
  } @if(showRationale) {
  <button
    mat-flat-button
    id="continue-button"
    [mat-dialog-close]="result"
    matTooltip="Continue"
    matTooltipShowDelay="1000"
    aria-label="Continue"
  >
    Continue
    <mat-icon>arrow_forward</mat-icon>
  </button>
  }
</mat-dialog-actions>
